<template>
  <!--  <el-tabs @tab-click="_click">-->
  <!--    <el-tab-pane v-for="menu in routeMenus" :label="menu.name" :name="menu.id">dffd</el-tab-pane>-->
  <!--  </el-tabs>-->
  <el-menu
    :default-active="$route.name"
    :active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    text-color="rgba(255,255,255,0.6)"
    active-text-color="#fff"
    @select="handleSelect"
    :router="true"
  >
    <template v-for="menu in routeMenus">
      <el-menu-item
        :class="{'currentActive':isActiveTar.flag && (isActiveTar.path === '/' + menu.id)}"
        v-if="menu.parentId === '0'"
        :key="menu.id"
        :data="menu"
        :index="menu.id"
        :route="'/' + (menu.id?menu.id:menu.href)"
        @click="_click(menu)"
      >&nbsp;{{menu.name}}</el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import { routeMenuChilds } from './activeMenu'
export default {
  data () {
    return {
      routeMenus: window.routeMenus,
      activeIndex: '0',
      routeMenuChilds
    }
  },
  computed:{
    isActiveTar(){
      let flag = false
      let path = ''
      this.routeMenuChilds.forEach(item=>{
        if(flag){
          return 
        }
        flag = item.children.find(v=> v === this.$route.path)?true:false
        path = item.path
      })
      return { flag, path }
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      // console.log(key, keyPath);
    },
    _click (item) {
      // const menu = routeMenus[item.index];
      let chillren = JSON.stringify(item)
      // this.$router.replace("/"+menu.href)
      this.$emit('subItem', chillren)
      
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "~@/style/theme.scss";

.el-menu-item {
  font-size: 16px;
  padding: 0 15px;
}

.el-menu {
  background-color: $maincolor;
}
.el-menu-item:active {
  background-color: $activecolor !important;
  // color: #fff;
  // span {
  //   color: #fff !important;
  // }
}
.el-menu-demo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-menu-demo >>> .is-active{
  border-bottom-color:transparent!important;
  background-color: $hovercolor !important;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: $hovercolor !important;
  color: $whiteColor !important;
  // i {
  //   color: black;
  // }
}
.currentActive{
  background-color: $hovercolor !important;
  color: $whiteColor !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/titleBar.vue